<template>
  <div class="RefundAuditListViewContainer">
    <nut-row class="pd16 box">
      <InfiniteLoadingList :query-id="5" ref="refundList">
        <template v-slot="data">
          <RefundOrderCard :data="data.data" @fresh="$refs.refundList.refresh()"/>
        </template>
      </InfiniteLoadingList>
    </nut-row>
  </div>
</template>

<script>
import InfiniteLoadingList from "@/components/InfiniteLoadingList";
import RefundOrderCard from "@/components/sale/RefundOrderCard.vue";

export default {
  name: "RefundAuditListView",
  components: {RefundOrderCard, InfiniteLoadingList, },
  data() {
    return {

    }
  },
  methods: {
    init() {
    },
  },
  mounted() {
    this.init()
    document.title = '退款审批列表'
  }
}
</script>

<style lang="scss" scoped>
.RefundAuditListViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
}
</style>